module.exports = __webpack_public_path__ + "media/images/icons/contrast-103a8c35a58cf347a9e9edfbdb010bbf.svg";